import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-flexbox-grid'

import { FaIcon } from '../../../shared/components'
import DeleteCategoryPopupSimGolf from './popups/delete_category_popup_sim_golf'
import AddEditCategoryPopupSimGolf from './popups/add_edit_category_popup_sim_golf';

const CategoryHeaderSimGolf = ({
  name,
  opened,
  onClick,
  loadingData,
  color,
  deleteCategory,
  id,
  specialStatus,
  categories,
  updateCategoriesSimGolf,
  updateURL,
  userIsCustomerManager,
}) => {
  const [displayDeletePopup, setDisplayDeletePopup] = useState(false)
  const [openSideDrawer, setOpenSideDrawer] = useState(false)

  const handleDeleteCategory = () => {
    setDisplayDeletePopup(false)
    deleteCategory(id)
  }

  return (
    <Fragment>
      <style className='hidden'>
        {`
          #category_header_${id} {
            border-left: 4px solid ${color};
          }
        `}
      </style>
      <div id={ `category_header_${id}` } className='list_header_sim_golf'>
        <div className={ `${opened && 'table_open'} row_container` } onClick={ onClick }>
          <Col xs={ 9 }>
            <span className='title'>
              { name }
            </span>
            { loadingData && (
              <Fragment>
                <span>
                  <span className='category_preloader_container'>
                    <span className='category_preloader' />
                  </span>
                </span>
              </Fragment>
            )}
          </Col>
          { opened &&
            <span className='action_icons_container'>
              <div className={`${userIsCustomerManager ? '' : 'disabled'} pencil_icon`} onClick={ () => setOpenSideDrawer(true) }>
                <img src={ require('pen.svg') }/>
              </div>
              <div
                xs={ 1 }
                className={ `${specialStatus !== null || userIsCustomerManager ? '' : 'disabled' } trash_icon` }
                onClick={ () => specialStatus === null && setDisplayDeletePopup(true) }
                title={specialStatus !== null && window.I18n.t('customer_center_comp.components.sim_golf_buttons.can_not_be_deleted') }
              >
                <img src={ require('trash.svg') }/>
              </div>
            </span>
          }
          <span className='arrow_icon'>
            <FaIcon icon={ opened ? 'angle-up' : 'angle-down' } className='pull-right' />
          </span>
        </div>
      </div>
      <table style={ {display: 'none'} }>
        <tbody />
      </table>
      { displayDeletePopup &&
        <DeleteCategoryPopupSimGolf
          displayPopup={ displayDeletePopup }
          setDisplayPopup={ setDisplayDeletePopup }
          name={ name }
          deleteCategory={ handleDeleteCategory }
        />
      }
      {openSideDrawer &&
        <AddEditCategoryPopupSimGolf
          displayPopup={ openSideDrawer }
          setDisplayPopup={ setOpenSideDrawer }
          title={ window.I18n.t('customer_center_comp.components.drawer.edit_title') || '' }
          categories={ categories }
          name={ name }
          opened={ opened }
          onClick={ onClick}
          loadingData={ loadingData }
          color={ color }
          deleteCategory={ handleDeleteCategory }
          id={ id }
          displayDeletePopup={ displayDeletePopup }
          setDisplayDeletePopup={ setDisplayDeletePopup }
          updateCategoriesSimGolf={ updateCategoriesSimGolf }
          updateURL={ updateURL }
        />
      }
    </Fragment>
  )
}

CategoryHeaderSimGolf.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  opened: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  updateCategoriesSimGolf: PropTypes.func.isRequired,
  categories: PropTypes.object.isRequired,
  userIsCustomerManager: PropTypes.bool.isRequired,
  specialStatus: PropTypes.string,
  updateURL: PropTypes.string,
  loadingData: PropTypes.bool,
}

export default CategoryHeaderSimGolf
